import { ALP_URL, PRODUCT_URL } from 'constants/links';
import {
  FeatureFlagProps,
  UserDetailsProps
} from './_components/customer-account/types';
import { navigateTo } from '@cat-ecom/common/utils/browserUtils';
import { getSeoUrl } from 'utils/links';
import { Params } from 'next/dist/shared/lib/router/utils/route-matcher';

export const getSideMenuList = (
  userDetail?: UserDetailsProps,
  featureFlags?: FeatureFlagProps
) => {
  const isServiceInsightFlag =
    userDetail?.isCspUser &&
    featureFlags?.PCC_HEADLESS_SERVICE_INSIGHTS_CUSTOMER_FLAG;
  return {
    my_eqp: {
      name: 'MY_EQP',
      label: 'SIS_EQUIP_LIST',
      is_active: true,
      tab_id: 0,
      ga_event_name: 'e_facetNav',
      ga_nltext: 'My Equipment',
      ga_context: 'Homepage Menu',
      isHide: false
    },
    service_insights: {
      name: 'SERVICE_RECOMMENDATIONS',
      label: 'SERVICE_RECOMMENDATIONS',
      is_active: false,
      tab_id: 1,
      ga_event_name: 'e_facetNav',
      ga_nltext: 'service insights',
      ga_context: 'Homepage Menu',
      isHide: !isServiceInsightFlag
    },
    recently_viewed: {
      name: 'RECENTLY_VIEWED',
      label: 'RECENTLY_VIEWED',
      is_active: false,
      tab_id: 2,
      ga_event_name: 'e_facetNav',
      ga_nltext: 'recent orders',
      ga_context: 'Homepage Menu',
      isHide: false
    }
  };
};

export const getFormatedSeoUrl = (seoUrl: string, params: Params) => {
  const { esite, lang } = params;
  return seoUrl.replace(`/${lang}/${esite}`, '');
};

export const navigateToSeoUrl = (
  featureFlag: FeatureFlagProps,
  seoUrl: string,
  params: Params,
  partNumber: string
) => {
  const formattedSeoUrl = getFormatedSeoUrl(seoUrl, params);
  const alpUrl = featureFlag.PCC_HEADLESS_ASSETLANDINGPAGE
    ? `${ALP_URL}${formattedSeoUrl}`
    : formattedSeoUrl;
  const pdpUrl =
    partNumber && featureFlag.PCC_Headless_PDPEMURGE
      ? `${PRODUCT_URL}/${partNumber}`
      : alpUrl;
  const url = getSeoUrl(params, pdpUrl);
  navigateTo(url);
};
